import React from 'react';
import './Privacy.css';

function Privacy() {
    return (
        <div className="legal-wrapper">
            <div className="legal-container">
                <h1>Privacy Policy</h1>
                <p><strong>Last Updated:</strong> 28.11.2024</p>

                <h2>1. No Personal Data Collected</h2>
                <p>
                    RanchersLand does not collect, store, or process any personal data. We do not use tracking tools, analytics systems, or retain identifiable information on our servers.
                </p>

                <h2>2. Blockchain Transparency</h2>
                <p>
                    All in-game actions and transactions occur on the WAX blockchain and are publicly verifiable. Your WAX wallet address is visible on the blockchain, but it is never stored or processed by us.
                </p>

                <h2>3. Cookies</h2>
                <p>
                    We use only essential, technical cookies necessary for basic site functionality. These cookies remain on your local device and are never sent to or processed by our servers.
                </p>

                <h2>4. External Wallet Providers</h2>
                <p>
                    You may connect via external wallet providers like Wax Cloud Wallet or Anchor. Any data processed by those third parties is governed by their respective privacy policies.
                </p>

                <h2>5. Contact</h2>
                <p>
                    If you have any questions, feel free to contact us at <a href="mailto:rancherland@gmail.com">rancherland@gmail.com</a>.
                </p>
            </div>
        </div>
    );
}

export default Privacy;
